import { render } from "./enable.vue?vue&type=template&id=453235c6&scoped=true"
import script from "./enable.vue?vue&type=script&lang=js"
export * from "./enable.vue?vue&type=script&lang=js"

import "./enable.vue?vue&type=style&index=0&id=453235c6&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453235c6"]])

export default __exports__